import gql from 'graphql-tag';

export const QUERY_GET_SAP = gql`
  query getDiscovers($personId: ID!) {
    getDiscovers(personId: $personId) {
      id
      data
    }
  }
`;



// WEBPACK FOOTER //
// ./src/services/graphql/discover-query.js